import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { PageRoutes } from '../constants/pages-routes';
import { UserPermissionInitializerService } from '../services/user-permission-initializer.service';

@Injectable({ providedIn: 'root' })
export class PermissionsGuard implements CanActivate {
  constructor(
    private router: Router,
    private permissionService: UserPermissionInitializerService
  ) { }

  private previousUrl = '';

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isRouteChanged = await this.hasRouteChanged(route);
    if (isRouteChanged) {
      await this.permissionService.loadPermissions(isRouteChanged);
    }
    return this.checkPermission(route);
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean> {
    const isChildRouteChanged = await this.hasRouteChanged(childRoute);
    if (isChildRouteChanged) {
      await this.permissionService.loadPermissions(isChildRouteChanged);
    }
    return this.checkPermission(childRoute);
  }

  private async hasRouteChanged(route: ActivatedRouteSnapshot): Promise<boolean> {
    const currentUrl = this.router.url;
    const isRouteChanged = currentUrl !== this.previousUrl;
    this.previousUrl = currentUrl;
    return isRouteChanged;
  }


  private async checkPermission(route: ActivatedRouteSnapshot): Promise<boolean> {
    const required: string[] = route.data['permissions']?.only || [];
    const except: string[] = route.data['permissions']?.except || [];
    const userPermissions = await this.permissionService.getPermissions();

    if (except.length > 0) {
      const hasRequired = except.some((perm) => userPermissions.includes(perm));
      if (!hasRequired) return true;
    }

    if (required.length > 0) {
      const hasRequired = required.some((perm) =>
        userPermissions.includes(perm)
      );
      if (hasRequired) return true;
    }

    this.router.navigate(['/', PageRoutes.PAGE, PageRoutes.PAGE_NOT_FOUND]);
    return false;
  }
}
